var ThumbnailsView, View, template, utils, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/thumbnails');

View = require('views/base/view');

utils = require('lib/utils');

module.exports = ThumbnailsView = (function(_super) {
  __extends(ThumbnailsView, _super);

  function ThumbnailsView() {
    _ref = ThumbnailsView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  ThumbnailsView.prototype.template = template;

  ThumbnailsView.prototype.tagName = 'div';

  ThumbnailsView.prototype.id = 'thumbnails';

  ThumbnailsView.prototype.autoRender = true;

  ThumbnailsView.prototype.$list = null;

  ThumbnailsView.prototype.events = {
    'click .thumb-list li': 'goToPage',
    'touchstart .thumb-list li': 'goToPage',
    'mouseover .thumb-list li': 'showThumbPopup',
    'mouseout .thumb-list li': 'hideThumbPopup'
  };

  ThumbnailsView.prototype.listen = {
    'catalogue:loaded mediator': 'init',
    'catalogue:pageTurned mediator': 'moveToPage'
  };

  ThumbnailsView.prototype.goToPage = function(e) {
    var page;
    e.stopPropagation();
    page = $(e.currentTarget).attr('data-page');
    this.publishEvent('catalogue:goToPage', parseInt(page));
    return false;
  };

  ThumbnailsView.prototype.init = function(catalogue) {
    this.model = catalogue;
    return this.render();
  };

  ThumbnailsView.prototype.attach = function() {
    ThumbnailsView.__super__.attach.apply(this, arguments);
    return this.$list = this.$('ul');
  };

  ThumbnailsView.prototype.moveToPage = function(page) {
    var activeItem, positionOfItem;
    activeItem = this.$list.find("li[data-page='" + (page.join(',')) + "']");
    this.$list.find('li').removeClass('active');
    activeItem.addClass('active');
    positionOfItem = activeItem.position();
    return this.$list.animate({
      'left': -positionOfItem.left
    });
  };

  ThumbnailsView.prototype.showThumbPopup = function(e) {
    var $el, activePage;
    if (utils.isMobile.any()) {
      return false;
    }
    $el = $(e.currentTarget);
    activePage = $el.attr('data-page').split(',');
    this.publishEvent('thumnails:showPopup', activePage, $el.offset());
    return false;
  };

  ThumbnailsView.prototype.hideThumbPopup = function() {
    if (utils.isMobile.any()) {
      return false;
    }
    this.publishEvent('thumbnails:mouseout');
    return false;
  };

  return ThumbnailsView;

})(View);
